import { AttachMoney, Numbers, TextFields } from '@mui/icons-material';

export const FieldTypeEnumValue = {
  String: 0,
  Number: 1,
  Amount: 2,
};

const fieldTypeArray = [
  {
    value: FieldTypeEnumValue.String,
    name: 'String',
    labelEnglish: 'Text (default)',
    labelFrench: 'Texte (défaut)',
    icon: TextFields,
    iconColor: '#6C63FF',
  },
  {
    value: FieldTypeEnumValue.Number,
    name: 'Number',
    labelEnglish: 'Numeric',
    labelFrench: 'Numérique',
    icon: Numbers,
    iconColor: '#26A69A',
  },
  {
    value: FieldTypeEnumValue.Amount,
    name: 'Amount',
    labelEnglish: 'Amount ($)',
    labelFrench: 'Montant ($)',
    icon: AttachMoney,
    iconColor: '#FFB300',
  },
];

const FieldTypeEnum = {};
fieldTypeArray.forEach(type => {
  FieldTypeEnum[type.value] = type;
});

FieldTypeEnum.array = fieldTypeArray;

export default FieldTypeEnum;
